import React from 'react';
import ProductStage from '@/components/product/ProductStage';

/**
 * Shared visual stage for the Writer entry surfaces.
 *
 * Ruled paper field, pooled light and two slow orbs — the signature the
 * signed-out /write landing established. Both the guest landing and the
 * signed-in Writer home render it so the two can never drift apart.
 *
 * Purely decorative: every layer is aria-hidden and pointer-events none.
 */

interface WriterStageProps {
  className?: string;
  children?: React.ReactNode;
}

const WriterStage: React.FC<WriterStageProps> = ({ className, children }) => (
  <ProductStage className={className} testId="writer-stage">{children}</ProductStage>
);

export default WriterStage;
